/* eslint-disable */
import React from 'react';
import Rive from '@rive-app/react-canvas';
const ModalLoader = props => (
	<div className="showModalLoader">
		<Rive src="/rive_loader.riv" style={{width:'150px', height: "150px"}}/>
	</div>
			
);

export default ModalLoader;
